import BudgetsPage from './budgets';

export default BudgetsPage;
